import { Injectable } from '@angular/core'
import { Observable, BehaviorSubject, fromEvent } from 'rxjs'
import { debounceTime, map, pluck } from 'rxjs/operators';
import { Subject } from 'rxjs';
// import { EventMessages } from '../providers/state/state.provider'

import { Teacher } from '../models/teacher';

@Injectable()
export class EventService {

  private loggedIn = new Subject();
  loggedInSource$ = this.loggedIn.asObservable();

  publishLoggedIn() {
    this.loggedIn.next(null)
  }


  private loggingIn = new Subject();
  loggingInSource$ = this.loggingIn.asObservable();

  publishLoggingIn(credentials: any){
    this.loggingIn.next(credentials);
  }


  private loggingInError = new Subject();
  loggingInErrorSource$ = this.loggingInError.asObservable();

  publishLoggingInError(){
    this.loggingInError.next(null);
  }



  private loggedOut = new Subject();
  loggedOutSource$ = this.loggedOut.asObservable();

  publishLoggedOut(){
    this.loggedOut.next(null)
  }




  private dirtyTeacherData = new Subject();
  dirtyTeacherDataSource$ = this.dirtyTeacherData.asObservable();

  publishDirtyTeacherData(teacher: Teacher) {
    this.dirtyTeacherData.next(teacher)
  }

  private apiError = new Subject();
  apiErrorSource$ = this.apiError.asObservable();

  publishApiError(error: object) {
    this.apiError.next(error)
  }


  private authorize = new Subject();
  authorize$ = this.authorize.asObservable();

  publishAuthorize() {
    this.authorize.next(null)
  }

  ngOnDestroy(){
    this.loggedIn.unsubscribe();
    this.loggingIn.unsubscribe();
    this.loggingInError.unsubscribe();
    this.loggedOut.unsubscribe();
    this.dirtyTeacherData.unsubscribe();
    this.apiError.unsubscribe();
    this.authorize.unsubscribe();
  }

}
